import { render } from "./PrinterSetups.vue?vue&type=template&id=3d7b747c&ts=true"
import script from "./PrinterSetups.vue?vue&type=script&lang=ts"
export * from "./PrinterSetups.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__